var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-embed',{attrs:{"type":"iframe","src":this.data,"allowfullscreen":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }